 export const actualizarObjetoEnArray=(array:any, nombreProp:any, valorProp:any, nuevasPropiedades:any) => {
   return array.map((obj:any) => {
       if (obj[nombreProp] === valorProp) {
         return {
              ...obj,
              ...nuevasPropiedades
          };
      } else {  
          return obj;
      }
  });
}